import { FC } from 'react';
import styled from 'styled-components';
import { ColorModule } from '@tools/ui-utils/theme.util';

const Rectangle = styled.div<{ color: string }>`
  font-weight: 600;
  color: white;
  background-color: ${(props) => props.color};
  justify-content: center;
  align-items: center;
  display: inline-flex;
`;

const SwitcherRectangle = styled(Rectangle)<{ color: string }>`
  font-size: 16px;
  height: 24px;
  width: 24px;
  border-radius: 5px;
`;

const SideContainerRectangle = styled(Rectangle)<{ color: string }>`
  font-size: 32px;
  height: 80px;
  width: 80px;
`;

export enum RectangleType {
  switcher,
  sideContainer,
}

type IProps = {
  name: string;
  type: RectangleType;
  color?: ColorModule;
};

export const RectangleModule: FC<React.PropsWithChildren<IProps>> = ({
  name,
  type,
  color = ColorModule.DEFAULT,
}: IProps) => {
  const text = name.substring(0, 1).toUpperCase();

  return type === RectangleType.switcher ? (
    <SwitcherRectangle color={color}>{text}</SwitcherRectangle>
  ) : (
    <SideContainerRectangle color={color}>{text}</SideContainerRectangle>
  );
};
